/**
 * Initializes email validation with debounce and inline error display.
 * Targets the `.signup.update_email` and `.sbsa-signup.update_email` views.
 */
export function initEmailValidation() {
  const emailInput = document.getElementById("email-input-field");
  const submitButton = document.getElementById("update-email-button");
  if (!emailInput || !submitButton) return;

  const debounce = (func, delay = 500) => {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => func.apply(null, args), delay);
    };
  };

  const isValidEmail = (email) =>
    /^(?!.*\.\.)(?!\.)([^\.\ ]?[A-Za-z0-9._%+\-`$!&#*'=?^{|}~]*[^.@])(@)(?!-)(?!\.)([^@.-]?(?!.*--)(?!.*,)(?!.*\.-)(?!.*-\.)[A-Za-z0-9\-\.]*[^@.,\+-])((?!@).?)[^-][^@.,+-]?[A-Za-z0-9-](?!@)[^(..),>\ -]$/i.test(
      email,
    );

  const toggleErrorMessage = (
    inputElement,
    isInvalid,
    message = "Please enter a valid email address.",
  ) => {
    const wrapper =
      inputElement.closest(".form-group") || inputElement.parentNode;
    let errorEl = wrapper && wrapper.querySelector(".invalid-feedback");

    inputElement.classList.toggle("is-invalid", isInvalid);
    submitButton.disabled = isInvalid || !inputElement.value.trim();

    if (isInvalid) {
      if (!errorEl) {
        errorEl = document.createElement("div");
        errorEl.className = "invalid-feedback";
        wrapper.appendChild(errorEl);
      }
      errorEl.textContent = message;
    } else if (errorEl) {
      errorEl.remove();
    }
  };

  const validate = debounce(() => {
    const value = emailInput.value.trim();
    if (!value) {
      toggleErrorMessage(emailInput, false);
      submitButton.disabled = true;
      return;
    }
    toggleErrorMessage(emailInput, !isValidEmail(value));
  });

  emailInput.addEventListener("input", validate);
}
